import(/* webpackMode: "eager" */ "/vercel/path0/app/(content)/npapps/page.tsx");
